var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import './main.scss';
import parse from 'html-react-parser';
import gsap from 'gsap';
var LogoDisplay = function (_a) {
    var _b = _a.data, headlineText = _b.headlineText, headlineSummary = _b.headlineSummary, logo_cta = _b.logo_cta, disclosure = _b.disclosure;
    useEffect(function () {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.logo-display-section',
                start: 'top center',
            },
        });
        tl.fromTo(['.logo-display-text', '.logo-display-images'], {
            opacity: 0,
            duration: 0.5,
            stagger: 0.5,
        }, {
            opacity: 1,
            duration: 0.5,
            stagger: 0.5,
        });
    }, []);
    return (_jsxs("div", __assign({ className: "logo-display-section relative snap-center bg-enblue-500 w-full text-white" }, { children: [headlineText && (_jsx("h2", __assign({ className: "logo-display-text justify-self-center" }, { children: parse(headlineText) }), void 0)),
            headlineSummary && (_jsx("div", __assign({ className: "logo-display-text--summary justify-self-center" }, { children: parse(headlineSummary) }), void 0)),
            _jsx("div", __assign({ className: "logo-display-images" }, { children: logo_cta.map(function (item) {
                    return (_jsxs("div", __assign({ className: "logo-display-image" }, { children: [item.url && (_jsx("a", __assign({ href: item.url, rel: "noreferrer", target: "_blank" }, { children: item.url && (_jsx("img", { className: "", src: item.src, alt: item.alt }, void 0)) }), void 0)),
                            !item.url && _jsx("img", { className: "", src: item.src, alt: item.alt }, void 0)] }), item.src));
                }) }), void 0),
            disclosure && (_jsx("div", __assign({ className: "disclosure-display-text justify-self-center" }, { children: parse(disclosure) }), void 0))] }), void 0));
};
export default LogoDisplay;
